
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"35","height":"35"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"id":"a","x1":"1","y1":".5","x2":"0","y2":".5","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#a0b522"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#6a911f"}})])]),_c('g',{attrs:{"data-name":"Group 12577"}},[_c('circle',{attrs:{"data-name":"Ellipse 183","cx":"17.5","cy":"17.5","r":"17.5","fill":"url(#a)"}})]),_c('g',{attrs:{"data-name":"Group 12614"}},[_c('path',{attrs:{"data-name":"Path 9715","d":"M15.73 27.548a1.424 1.424 0 00.43-2.815 7.49 7.49 0 118.682-7.513h-2.776a.2.2 0 00-.14.324l4.206 5.727a.176.176 0 00.285 0l4.206-5.727a.2.2 0 00-.14-.324h-2.781A10.339 10.339 0 1015.73 27.548z","fill":"#fff"}})])])
          )
        }
      }
    